<template>
  <div>
    <h1 class="welcome-text">Hello {{ user.email }}</h1>
  </div>
</template>

<script>
export default {
  computed: {
    user() {
      return this.$store.state.user
    }
  }
}
</script>

<style lang="scss" scoped>
.welcome-text {
  font-size: 20px;
}
</style>
